var data = {
	"body": "<path d=\"M19 12c0 3.86-3.14 7-7 7s-7-3.14-7-7s3.14-7 7-7s7 3.14 7 7z\" fill=\"currentColor\"/>",
	"width": 24,
	"height": 24
};
export default data;
